import MapView from '@arcgis/core/views/MapView';
import arcGisFactory from '../../../arcGIS/arcgis-factory';
import { MapPlugin, MapPlacement } from '../arcgis-types';

export default function DefaultPlugins(): MapPlugin {
  return {
    extendMap: (view: MapView) => {
      const factory = arcGisFactory();
      const locateWidget = factory.newLocateWidget({ view, id: 'locate' });
      const scaleWidget = factory.newScaleBarWidget({ view });

      view.ui.add(locateWidget, MapPlacement.TopLeft);
      view.ui.add(scaleWidget, MapPlacement.BottomRight);
    },
  };
}
